<a [routerLink]="['/player/details', Player.LifelineScoutingId]" style="color: white;">
  <mat-form-field style="width: 300px;"  appearance="fill"  class="smalltext"   >

    @if (Player.ProfileImage!=null) {
      <img [src]="'/assets/' + Player.ProfileImage" style="width: 45px;">
    }

    <mat-label>Player</mat-label>

    <input matInput maxlength="100" class="smalltext" [value]="fullname()" disabled />

  </mat-form-field>
</a>
